import type { ProductSlimResponseDTO } from '@shared/DTO';

/** Shared precedence for product cards and summaries, without changing the DTO. */
export function getProductRating(product: ProductSlimResponseDTO) {
  if (product?.reviewStats?.ratingCount) {
    return { ratingAvg: Math.round((product.reviewStats.ratingAvg ?? 0) * 10) / 10, ratingCount: product.reviewStats.ratingCount };
  }
  const score = product?.productData?.score;
  if (score) return { ratingAvg: Math.round(score * 10) / 10, ratingCount: undefined };
  return undefined;
}
